/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte Framework package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

// Bypass inspection for undefined variable $event in .vue files.
// noinspection JSUnusedLocalSymbols
const $event = undefined;

import Vue from "vue";

import * as Components from "./component";

Object.values(Components).forEach(c => Vue.component(c.name, c));

Latte.core.register(Latte =>
{
	Latte.action.on("hub:apps:view", ({namespace}) => window.location = `/admin/hub/apps/app/${namespace}`);

	Vue.filter("hubNumberFormat", value => (new Intl.NumberFormat()).format(value))
});

import "./installations";
import "./notifications";
